import { Tag } from 'antd';
import classnames from 'classnames';
import React from 'react';

export default function CheckableTags({ options, selectedOption, extra, onChange }) {
  return (
    <div className="flex gap-xs flex-wrap items-center">
      {options.map((item, idx) => (
        <Tag.CheckableTag
          key={`option-${idx}`}
          checked={selectedOption?.id === item.id}
          onChange={(checked) => checked && onChange(item)}
          className={classnames('text-base rounded-2xl py-2xs px-sm mr-none h-fit', {
            'bg-gray-200': selectedOption?.id !== item.id,
          })}
        >
          {item.label}
        </Tag.CheckableTag>
      ))}
      {extra}
    </div>
  );
}
